import * as __WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__ from "@sentry/react";
import * as __WEBPACK_EXTERNAL_MODULE__init_utils_mjs_807181fc__ from "./init/utils.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__integrations_mjs_aeb612a8__ from "./integrations.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__redux_enhancer_createSentryReduxEnhancer_mjs_cac3eecc__ from "./redux-enhancer/createSentryReduxEnhancer.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__pushAxiosDataToSentry_mjs_88220f76__ from "./pushAxiosDataToSentry.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__pushRequestIdToSentry_mjs_91d654b3__ from "./pushRequestIdToSentry.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__init_browserClient_mjs_f64589bf__ from "./init/browserClient.mjs";
const configureAndInitSentry = (config)=>{
    if (process.env.SSR) return;
    const { sentryLoggingEnabled, isDebug } = config;
    if (isDebug) console.error('Initing Sentry with config', config);
    if (!sentryLoggingEnabled) return;
    const environment = (0, __WEBPACK_EXTERNAL_MODULE__init_utils_mjs_807181fc__.getEnvironment)();
    const isSupportedBrowser = (0, __WEBPACK_EXTERNAL_MODULE__init_utils_mjs_807181fc__.isBrowserSupported)();
    const isLoggingEnabled = isSupportedBrowser || environment.isAutotests;
    if (!isLoggingEnabled) return;
    const { clientConfig, externalConfig } = (0, __WEBPACK_EXTERNAL_MODULE__init_utils_mjs_807181fc__.prepareConfig)(config, {
        isRootClient: true
    });
    const client = __WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__.init({
        ...clientConfig,
        integrations: (0, __WEBPACK_EXTERNAL_MODULE__integrations_mjs_aeb612a8__["default"])({
            jsBuildFilterKey: config.jsBuildFilterKey,
            replaysOnErrorSampleRate: clientConfig.replaysOnErrorSampleRate,
            tracesSampleRate: clientConfig.tracesSampleRate
        }),
        transport: __WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__.makeFetchTransport,
        debug: config.isDebug
    });
    return {
        client,
        createSentryReduxEnhancer: (options)=>(0, __WEBPACK_EXTERNAL_MODULE__redux_enhancer_createSentryReduxEnhancer_mjs_cac3eecc__["default"])((0, __WEBPACK_EXTERNAL_MODULE__redux_enhancer_createSentryReduxEnhancer_mjs_cac3eecc__.prepareSentryReduxEnhancerOptions)(options, {
                redactedFields: config.redactedFields
            }, externalConfig))
    };
};
const src_rslib_entry_ = configureAndInitSentry;
var __webpack_exports__initBrowserClient = __WEBPACK_EXTERNAL_MODULE__init_browserClient_mjs_f64589bf__["default"];
var __webpack_exports__prepareAxiosErrorDataInterceptor = __WEBPACK_EXTERNAL_MODULE__pushAxiosDataToSentry_mjs_88220f76__.prepareAxiosErrorDataInterceptor;
var __webpack_exports__pushAxiosDataToSentry = __WEBPACK_EXTERNAL_MODULE__pushAxiosDataToSentry_mjs_88220f76__["default"];
var __webpack_exports__pushRequestIdToSentry = __WEBPACK_EXTERNAL_MODULE__pushRequestIdToSentry_mjs_91d654b3__["default"];
export { src_rslib_entry_ as default, __webpack_exports__initBrowserClient as initBrowserClient, __webpack_exports__prepareAxiosErrorDataInterceptor as prepareAxiosErrorDataInterceptor, __webpack_exports__pushAxiosDataToSentry as pushAxiosDataToSentry, __webpack_exports__pushRequestIdToSentry as pushRequestIdToSentry };

//# sourceMappingURL=index.mjs.map